import { z } from "zod";

import { DeviceKey, Id } from "./ids";
import { Plan, Seat } from "./People";

/** `GET /me`, and the answer to signing in: who the signed-in person is, their devices, groups and bands. */
export const Me = z.object({
    account: z.object({
        id: Id,
        name: z.string(),
        email: z.string(),
    }),
    devices: z.array(z.object({ key: DeviceKey, signedInAt: z.iso.datetime(), lastSeenAt: z.iso.datetime() })),
    groups: z.array(
        z.object({
            id: Id,
            plan: Plan,
            seat: Seat.nullable(),
            admin: z.boolean(),
            leaderSeats: z.int().nonnegative(),
            readerSeats: z.int().nonnegative(),
            /** The last day it's paid for, like `2027-10-25`. After that, its shared setlists stop syncing. */
            paidUntil: z.iso.date(),
        }),
    ),
    bands: z.array(z.object({ id: Id, groupId: Id })),
});

export type Me = z.infer<typeof Me>;
